export default {
  close: 'Close',
  dataIterator: {
    pageText: '{0}-{1} de {2}',
    noResultsText: 'No se han encontrado resultados para su búsqueda',
    loadingText: 'Carregando elementos...',
  },
  dataTable: {
    itemsPerPageText: 'Líneas por página:',
    ariaLabel: {
      sortDescending: ': Ordenada descendiendo. Activar para eliminar la clasificación.',
      sortAscending: ': Ordenada ascendente. Activar para ordenar descendente.',
      sortNone: ': No ordenado. Activar para ordenar ascendente.',
    },
    sortBy: 'Ordenar por',
  },
  dataFooter: {
    itemsPerPageText: 'Elementos por página:',
    itemsPerPageAll: 'Todas',
    nextPage: 'Siguiente página',
    prevPage: 'Página anterior',
    firstPage: 'Primera página',
    lastPage: 'Última página',
  },
  datePicker: {
    itemsSelected: '{0} elementos selecionados',
  },
  noDataText: 'No hay datos.',
  carousel: {
    prev: 'Ver anteriores',
    next: 'Ver siguientes',
  },
  calendar: {
    moreEvents: 'Más {0}',
  },
  fileInput: {
    counter: '{0} Archivos',
    counterSize: '{0} Archivos ({1} en total)',
  },
  observation: {
    accumulatedTemperature: 'Temperatura efectiva acumulada',
    accumulatedTemperatureList: 'Lista de temperatura efectiva acumulada',
    startDateCalculation: 'Fecha de inicio del cálculo',
    endDateCalculation: 'Fecha de finalización de la acumulación',
    lowerLimitTemperature: 'Temperatura límite inferior',
    registerAndEditAccumulatedTemperaturePoints: 'Registro/edición del punto de cálculo de la temperatura acumulada',
    period: 'Período',
    accumulatedLowerLimitTemperature: 'Temperatura límite inferior acumulada',
    deleteAccumulatedTemperatureLocation:
      '¿Está seguro de que desea eliminar los puntos de observación de la temperatura integrada de 「{fieldName}」?',
    soilMoisture: 'Humedad del suelo',
    soilTemperature: 'temperatura del suelo',
    precipitation: 'precipitaciones',
    soilMoistureList: 'Lista de la humedad del suelo',
    maxRegisterCount: '（Hasta {count} artículos）',
    soilConditionVeryWet: 'Sobre-humedad',
    soilConditionWet: 'Humedad adecuada',
    soilConditionDry: 'Sequedad',
    soilConditionVeryDry: 'Sobre-secado',
    drainage: 'Textura del suelo',
    registerAndEditSoilMoisturePoints: 'Registro/edición de los puntos de cálculo de la humedad del suelo',
    soilMoistureConditionGood: 'Franco arcilloso',
    soilMoistureConditionSlightlyBad: 'Un poco peor',
    soilMoistureConditionBad: 'Arcilla',
    soilMoistureConditionSandyLoam: 'Franco arcilloso',
    soilMoistureConditionClayLoam: 'Un poco peor',
    soilMoistureConditionClay: 'Arcilla',
    deleteSoilMoistureLocation:
      '¿Está seguro de que quiere eliminar los puntos de observación de la humedad del suelo en 「{fieldName}」?',
    deletedField: '< La parcela ha sido eliminada >',
    validateForStartDateBeforeYesterday: 'La fecha de inicio debe ser al menos un día antes de',
    validateForStartEndDateOrder: 'La fecha de finalización debe ser posterior a la fecha de inicio',
    validateForStartEndDuration: 'Las fechas de inicio y fin deben tener una diferencia de {day} días',
    validateForStartNowDuration: 'La fecha de inicio debe ser dentro de los {day} siguientes al presente',
  },
  caster: {
    rtkInfo: 'Información sobre la corrección RTK',
    rtkLog: 'Registro de comunicaciones',
    myBaseStationStatus: 'Estado de mi estación base',
    howToSetupRtkBase: 'Al enviar información de corrección desde un producto de otra empresa a "Mi estación base"',
    howToSetupRtkRover: 'Al recibir información de corrección de "Mi estación base" con el producto de otra empresa',
    host: 'Host',
    port: 'Puerto',
    mountpoint: 'Mount Point',
    derivedPassthroughLabel: ' (sin conversión)',
    derivedPassthroughCaption: 'Transmite las correcciones de la estación base tal cual. Opción habitual',
    derivedMsm4Label: ' (compatibilidad)',
    derivedMsm4Caption: 'Convertido a MSM4: para receptores inestables con el formato más reciente (p. ej. MSM7)',
    derivedLegacyLabel: ' (para receptores antiguos)',
    derivedLegacyCaption: 'Convertido al formato legado 1004/1012: solo GPS+GLONASS',
    derivedNote:
      'Si no recibe correcciones o no consigue FIX, pruebe _MSM4 / _LEGACY. Estas salidas pueden no estar disponibles si conecta una estación base ajena a AgriBus.',
    messageTypesTitle: 'Tipos de mensajes emitidos (detalles técnicos)',
    messageTypesIntro:
      'Si un fabricante de receptores pregunta qué mensajes RTCM emite la estación base, indique la siguiente lista según el punto de montaje utilizado.',
    messageTypesPassthrough:
      'Transmite la salida de la estación base sin cambios. Para nuestras estaciones base AgriBus-GMiniR: RTCM 3.3 / MSM4+MSM7 (1074/1077 GPS, 1084/1087 GLONASS, 1094/1097 Galileo, 1124/1127 BeiDou) cada segundo, más 1005 (posición de la estación), 1008 (información de antena) y 1230 (sesgos de código-fase GLONASS). Con estaciones base de otros fabricantes depende de su configuración',
    messageTypesMsm4:
      'Normalizado a RTCM 3.3 / MSM4: 1074 (GPS), 1084 (GLONASS), 1094 (Galileo), 1114 (QZSS), 1124 (BeiDou) cada segundo (solo las constelaciones que recibe la estación base), más 1006, 1033 y 1230 cada 5 segundos',
    messageTypesLegacy:
      'Formato antiguo (estilo RTCM 3.1): 1004 (GPS L1/L2) y 1012 (GLONASS L1/L2) cada segundo, más 1006 y 1008 cada 5 segundos (sin 1033/1230). Las marcas de tiempo de las observaciones se alinean a segundos enteros, por lo que también pueden usarse receptores que las esperan así',
    baseStation: 'Estación base',
    rover: 'Rover',
    userId: 'ID de usuario',
    ntripUserId: 'Ntrip ID de usuario',
    ntripPassword: 'Contraseña de Ntirp',
    showCaption: 'Mostrar',
    statusTab: 'Estado',
    qualityTab: 'Calidad',
    mapTab: 'Mapa',
    logTab: 'Registro de conexiones',
    settingsTab: 'Configuración',
    baseShort: 'Estación base',
    casterServer: 'Servidor caster',
    roverShort: 'Rover',
    receiving: 'Recibiendo',
    stale: 'Recepción estancada',
    noConnection: 'No conectado',
    lastReceivedAt: 'Última recepción',
    disconnectedAt: 'Desconectado',
    summaryTitle: 'Recepción de la estación base',
    lastSnapshotNote: 'Últimos valores antes de la desconexión',
    noStatsData: 'No se reciben datos de la estación base',
    bytesRate: 'Tasa de datos',
    messagesPerSecond: 'Mensajes',
    epochInterval: 'Intervalo de época',
    uptime: 'Tiempo conectado',
    decodeErrors: 'Errores de decodificación',
    basePosition: 'Posición de la base',
    antenna: 'Antena',
    satellites: 'Satélites',
    signals: 'Señales',
    meanCnr: 'C/N0 medio',
    msgType: 'Mensaje',
    msgCount: 'Recuento',
    msgInterval: 'Intervalo',
    msgLastSeen: 'Última recepción',
    cnrChart: 'C/N0 medio (dB-Hz)',
    satsChart: 'Satélites',
    rateChart: 'Tasa de datos (bytes/s)',
    epochChart: 'Intervalo de época (ms)',
    noHistoryData: 'Aún no hay datos históricos',
    noTrackData: 'Sin registros GGA del rover',
    baseline: 'Línea base',
    fixQuality: 'Calidad de fix',
    ggaPoints: 'Puntos registrados',
    logBaseTitle: 'Conexiones de la estación base',
    logRoverTitle: 'Conexiones de rovers',
    startAt: 'Inicio',
    endAt: 'Fin',
    inSession: 'Conectado',
    userAgentLabel: 'Cliente',
    logNote: 'Muestra los registros de las últimas 24 horas',
  },
  print: {
    field: {
      fillSetting: 'Rellene la parcela',
      backgroundWhiteColorSetting: 'Fondo blanco',
      backgroundNoColorSetting: 'Sin antecedentes',
      printText: 'Impresión',
      showFieldName: 'Mostrar el nombre de la parcela',
    },
  },
  sortOptions: {
    title: 'Ordenar por',
    field: {
      name: 'Nombre de la parcela',
      createdAt: 'Fecha de inscripción',
      lastModifiedDateTime: 'Fecha modificada',
    },
  },
  fieldElevation: {
    title: 'elevación',
    cantBuildBecauseNoTask: 'El historial de trabajo no existe, por lo que no es posible crear un mapa de alturas.',
    nowBuilding: 'Preparando... (Dependiendo de la superficie de la parcela, puede tomar algún tiempo para crear).',
    updatedAt: 'Fecha de creación',
    meshSize: 'Tamaño de la malla',
    taskFetchLimit: 'volumen de datos',
    taskDateRange: 'Alcance',
    taskPointCount: 'recuento de puntos de trabajo',
    editButton: 'Editar',
    createButton: 'Crear',
    needStandardPlan: 'El mapa de alturas requiere el plan estándar.',
    taskFetchLimitHint: 'Si no hay diferencia de altura, auméntela. Si hay mucho ruido, redúcelo.',
    creationFailedMessage: 'La creación del mapa de alturas ha fallado.',
    gnssStatus: 'Estado del GNSS',
    elevationRange: 'Rango de elevación',
    optionSetting: 'Ajuste de la opción',
    minValue: 'Valor mínimo',
    maxValue: 'Valor máximo',
    minIgnoreCaption: 'Se ignoran las elevaciones por debajo de este valor',
    maxIgnoreCaption: 'Las elevaciones por encima de este valor serán ignoradas',
    minValueNeedError: 'Por favor, establezca un valor mínimo',
    maxValueNeedError: 'Por favor, establezca el valor máximo',
    minValueRangeError: 'El valor mínimo debe ser menor que el valor máximo',
    maxValueRangeError: 'El valor máximo debe ser mayor que el valor mínimo',
    invalidOptionSettingError: 'Opción no válida especificada',
    dateRangeInput: 'Intervalo de fechas',
    oldestTaskDateInput: 'Fecha de inicio',
    newestTaskDateInput: 'Fecha final',
  },

  navi: {
    GeneralMainSettingMenuGnssSource: 'Fuente GNSS',
    GeneralMainSettingGnssSourceInternal: 'Interno',
    GeneralMainSettingGnssSourceGPlus: 'AgriBus-G+',
    GeneralMainSettingGnssSourceG2: 'AgriBus-G2',
    GeneralMainSettingGnssSourceGMini: 'AgriBus-GMini',
    GeneralMainSettingGnssSourceGMiniR: 'AgriBus-GMiniR',
    GeneralMainSettingGnssSourceUsb: 'USB',
    GeneralMainSettingGnssSourceBluetooth: 'Bluetooth',
    GeneralMainSettingGnssSourceTcpPort: 'Puerto TCP',
    GeneralMainSettingGnssSourceNtripClient: 'Cliente Ntrip (Trimble, Topcon)',
    GeneralMainSettingGnssSourceVirtual: 'Virtual',
  },

  ValidationTextRequired: 'Entrada requerida',
  ResetPasswordTitle: 'Restablecer contraseña',
  ResetPasswordButton: 'Restablecer la contraseña',
  ResetPasswordDescription: 'Un correo electrónico de confirmación ha sido enviado. Por favor revise su correo.',
  ValidationBadEmail: 'Dirección de correo electrónico incorrecta.',
  ChangePasswordButton: 'Cambia la contraseña',
  CreatePasswordButton: 'Crea una contraseña',
  UnitTitle: 'Unidad',
  UnitMetric: 'Métrico',
  UnitImperial: 'Imperial',
  UnitJpUnitsOfArea: 'Unidades de superficie japonesas',
  UnitThUnitsOfArea: 'Unidades de superficie tailandesas',
  NickNameHint: 'Apodo',
  SendMeNews: 'Enviéme la información más reciente.',
  FreePlanDisplayName: 'Plan Gratuito',
  StandardPlanDisplayName: 'Plan Estándar',
  ChangePasswordTitle: 'Cambia la contraseña',
  CreatePasswordTitle: 'Crear contraseña',
  CurrentPasswordHint: 'Contraseña actual',
  NewPasswordHint: 'Nueva contraseña',
  SignInButton: 'Iniciar sesión',
  ToResetPasswordButton: 'Reestabelecer contraseña',
  DocFormFieldDetailFieldNameHint: 'Nombre de la parcela',
  DocFormTaskRecordDetailFieldNameHint: 'Nombre del registro de trabajo.',
  DocFormTaskRecordDetailDescriptionHint: 'Descripción',
  DocFormTabNameTaskRecordList: 'Historial de actividades',
  DocFormTabNameRefLineList: 'Línea de referéncia',
  DocFormTabNameGridPointsList: 'Datos em tabla',
  DocFormTabNameFieldList: 'Parcelas',
  DocFormFieldRegisteredDateFormatBase: 'Registrado: {createDate}',
  DocFormMenuItemSignOut: 'Cerrar sessión',
  DocFormFieldDetailDescriptionHint: 'Descripción',
  StandardPlanIsNeededDialogMessage: 'disponible por la ompra del Plan Estándar (Prueba gratuita por 30 días)',
  SelectPlanDialogTitle: 'Seleccionar plan',
  SelectPlanDialogRecommend: 'Recomendado',
  SelectPlanDialogYearPlan: 'Plan anual',
  SelectPlanDialogYearPlanGreatValue: '(Descuento por 2 meses)',
  SelectPlanDialogYearMonth: 'Plan mensual',
  StandardPlanPriceForMonthBatch: 'Cuota anual',
  StandardPlanPricePerMonth: '/ Mes',
  StandardPlanPricePerYear: '/ Año',
  StandardPlanPriceForYearNotice: '* Pago por 12 meses',
  SelectPlanSubscribeYear: '30 días de prueba',
  SelectPlanSubscribeMonth: 'Comience la prueba de 30 días',
  selectPlanDataViewNote:
    '* Si no reanuda su suscripción en el plazo aproximado de un mes tras la cancelación, los datos registrados antes de la cancelación dejarán de mostrarse (aplicable a partir del 1 de octubre de 2026). Exporte los datos que necesite mientras su suscripción esté activa.',
  DefaultRefLineTypeStraight: 'Recta',
  DefaultRefLineTypeCurved: 'Curva',

  customSelectAll: 'Seleccionar todo',
  customUnSelectAll: 'Limpiar todo',
  customRegistration: 'Registro',
  customUpdate: 'Actualización',
  customSearch: 'Buscar',
  customDelete: 'Eliminar',
  customAllow: 'Permitir',
  customDeny: 'Negar',
  customDefault: 'Defecto',
  customSelected: 'Seleccionando',
  customSelectThis: 'Seleccionar esto',
  customArea: 'Zona',
  customNotAvailable: 'No disponible',
  customEdit: 'Editar',
  customCancel: 'Cancelar',
  customNone: 'Ninguno',
  customClose: 'Cerrar',
  customFieldDrawHint:
    'Haga clic en el mapa para agregar vertices y confirme con el boton de verificacion (boton deshacer / Retroceso elimina el ultimo punto)',
  customBack: 'Volver',
  customRefresh: 'Actualizar',
  customUpload: 'Cargar',
  customPriceIncludingTax: 'Precio (impuestos incluidos)',
  customPay: 'Pagar',
  customCancelContract: 'Cancelar suscripción',
  customConfirmReally: '¿Estás realmente seguro?',
  customRememberMe: 'Recuerdame',
  customLogin: 'Iniciar sesión',
  customNowLoggingIn: 'Iniciando sesión....',
  customEmail: 'Correo electronico',
  customPassword: 'Contraseña',
  customUser: 'Usuario',
  customUserSettings: 'Configuraciones de usuario',
  customSentEMailMessage: 'Correo electrónico enviado.',
  customNewPasswordReInput: 'Verificar contraseña',
  customValidationPasswordMinLength: 'El mostrador debe tener menos {length} caracteres',
  customValidationPasswordMaxLength: 'Demasiado largo',
  customValidationPasswordNotMatch: 'Las contraseñas no coinciden',
  customChangePasswordSuccess: 'Contraseña cambiada',
  customGoToLoginPageTitle: 'Regresar a la página de inicio de sesión',
  customYouDontHaveAccount: '¿No eres usuario?',
  customRegisterAgriBusWeb: 'Registrarse en AgriBus-Web',
  customChange: 'Cambiar',
  customLanguage: 'Idioma',
  customSaveAction: 'Salvar',
  customSaveSuccess: 'Salvado',
  customAddAction: 'Agregar acción',
  customPlan: 'Plan',
  customPlanExpirationDate: 'Fecha de vencimiento: {expirationDate}',
  customPlanDescription: 'Para cambiar su plan, es necesario hacerlo desde AgriBus-NAVI (aplicación de Android).',
  customPlanOnly: 'El uso de esta función requiere la compra  de un Plan Estándar.',
  customDetail: 'Detalle',
  customDatePickerNullAlert: 'Seleccione la fecha primero.',
  customTaskNotFound: 'Historial de trabajo no encontrado',
  customTaskNotFoundAtDate: 'No se puede encontrar el historial de trabajo para {date}',
  customErrorInitTasksFreePlan: 'El Plan Gratuito está limitado a un máximo de dos días de historia',
  customErrorInitTasksNoTasks: 'Si no se muestra nada, ¡ "Sincronice" con AgriBus-NAVI!',
  customErrorInitFieldsNoFields: 'O no se han registrado parcelas o la AgriBus-NAVI no se ha sincronizado.',
  customColored: 'Codificación de color',
  customHeight: 'Altitud',
  customHeightMap: 'Mapa de altitud',
  customSpeed: 'Velocidad',
  customDate: 'Fecha y hora',
  customWorkWidth: 'Ancho de trabajo',
  customWorkedArea: 'Área de trabajo',
  customOverlappedArea: 'Zona solapada',
  customTaskRecordEfficiency: 'Eficiencia de registro de trabajo',
  customDistance: 'Distancia de viaje',
  customWorkedTime: 'Tiempo de trabajo',
  customAverageSpeed: 'Velocidad media',
  customWorker: 'Operador',
  customDocFormTaskRecordDistanceOfFormatBase: '{distance} (promedia de {speed})',
  customDocFormTaskRecordWorkedAreaPercentageFormatBase: '{percentage}% de {fieldArea}',
  customDocFormTaskRecordWorkedAreaInfoFormatBase: '{areaPercentageText}, {efficiencyText}/h',
  customPageSuffix: 'Página(s)',
  customDisplayCount: 'Resultados mostorados',
  customTotalCount: 'Todas las entradas {count}',
  customListingModeSelf: 'Solo tu mismo',
  customListingModeAll: 'Incluidos los seguidos',
  customIconSettings: 'Configuración de iconos',
  customAccountHeader: 'Cuenta',
  customConnectionHeader: 'Conexión',
  customConnectionTitle: 'Conexión',
  customFollowRequest: 'Solicitud de seguimiento',
  customFollow: 'Seguir',
  customUnfollow: 'Dejar de seguir',
  customFollowing: 'Seguindo',
  customFollower: 'Seguidor',
  customHaveNoFollowings: 'No has seguindo a nadie.',
  customHaveNoFollowers: 'Sin seguidores',
  customInbox: 'Recibir',
  customOutbox: 'Enviar',
  customInboxEmpty: 'No se recibieron solicitudes de seguimiento',
  customOutboxEmpty: 'No se han enviado solicitudes de seguimiento',
  customSendFollowRequest: 'Enviar una solicitud de seguimiento',
  customSendFollowRequestMessage: 'Envié una solicitud de seguimiento.',
  customFollowRequestSelfRequestError: 'No se puede enviar solicitudes de seguimiento a usted mismo',
  customAllowFollowRequest: 'Aprobé la solicitud de seguimiento de {fromNickname}',
  customUnfollowMessage: 'Dejó de seguir',
  customUpdatedIconMessage: 'Icono cambiado',
  customIconNowSelected: 'Actualmente seleccionado',
  customIcon: 'icono predeterminado',
  customIconSettingsDescription: 'Le recomendamos que configure su propio icono.',
  customIconChangeToIcon: 'Cambiar a predeterminado',
  customGravatarIcon: 'Gravatar',
  customIconSettingsGravatarDescription: 'Si tiene el icono de Gravatar, es útil elegir esto.',
  customIconChangeToGravatar: 'Cambiar a Gravatar',
  customCustomIcon: 'Icono personalizado',
  customIconSettingsCustomDescription:
    'Puedes configurar tus fotos favoritas. Prepare un archivo JPEG"Puede configurar sus fotos favoritas. Prepare el archivo JPEG o PNG',
  customIconChangeToCustom: 'Seleccionar esto',
  customIconReUpload: 'Cargar de nuevo',
  customTemperature: 'Temperatura',
  customHumidity: 'Humedad',
  customWind: 'Velocidad del viento',
  customPressure: 'Presión atmosférica',
  customSunrise: 'Salída del sol',
  customSunset: 'Puesta de sol',
  customShowAllCropsDescription: 'Mostrar todo',
  customShowCurrentCropsDescription: 'Mostrar solo cultivos actuales',
  customProduct: 'Producto',
  customProductsNotFound: 'No se pudo encontrar un producto.',
  customColor: 'Color',
  customYear: 'Año',
  customCrop: 'Cultivo',
  customCropVariety: 'Variedad de cultivo',
  customDeleteCropConfirmationMessage:
    '¿Quieres eliminar {cropYear} {cropName} {cropVariety}? (Los datos asociados también se eliminarán).',
  customOperationType: 'Operación',
  customFilter: 'Filtrar',
  customOutOfField: 'Fuera de la parcela',
  customBillingPlan: 'Plan de precios',
  customBillingAndPayment: 'Cargos y pago',
  customBillingMethod: 'Método de pago',
  customBillingExistingCard: 'Tarjeta registrada',
  customBillingAddNewCard: 'Agregar nueva tarjeta',
  customBillingMethodConfirm: 'Verifica el método de pago',
  customBillingHistory: 'Declaración de pago',
  customCreditCard: 'Tarjeta de crédito',
  customCreditCardLast4: 'Últimos 4 dígitos',
  customCreditCardNameOnCard: 'Nombre en la tarjeta',
  customCreditCardInfo: 'Información de la tarjeta',
  customCreditCardAddCard: 'Agregar tarjeta',
  customCreditCardAddCardCaution1:
    'Su tarjeta no se cargará en este momento, pero se establecerá como predeterminada para futuros cargos.',
  customCreditCardAddCardCaution2:
    'Si desea pagar su factura, póngase en contacto con contact@agri-info-design.com antes de registrar su tarjeta.',
  customCreditCardNoCard: 'No hay tarjeta de crédito registrada',
  customCreditCardDeleteFailure: 'El registro de la tarjeta falló',
  customMyProducts: 'Mis productos',
  customMyProductsList: 'Lista de productos',
  customMyProductProduct: 'Producto',
  customMyProductProductNumber: 'Número de producto',
  customMyProductDataPlan: 'Plan de datos',
  customMyProductDataPlanSubscribe: 'Contratación de un plan de datos',
  customMyProductDataPlanSubscribeSuccessMessage: 'En breve se activará la comunicación 3G para {productNumber}',
  customMyProductDataPlanExpiredMessage: 'Expirado el {expiredDate}',
  customMyProductDataPlanCancelConfirmationMessage:
    'Si cancela este plan, se terminará la comunicación 3G. Además, los días restantes del contrato no pueden ser reembolsados. Sin embargo, incluso una vez que se cancela, es posible volver a firmar el plan nuevamente. ¿Estás realmente seguro?',
  customRealTime: 'Tiempo real',
  customRealTimeSettings: 'Configuración de tiempo real',
  customModel: 'Modelo',
  customSystemVersion: 'Versión del sistema',
  customWebMarkerIcon: 'Icono',
  customWebMarkerSetting: 'Configuraciones de marcador',
  customWebMarkerName: 'Nombre del marcador',
  customWebMarkerColor: 'Color de marcador',
  customRealtimeChooseYourDevice: 'Selecciona el dispositivo',
  customRealtimeDeviceNotActive: 'No activo',
  customElevation: 'Altitud',
  customGnss: 'GNSS',
  customSatellites: 'Satélite',
  customFirmwareVersion: 'Versión de firmware',
  customHasFirmwareUpdate: 'Actualización disponible',
  customFirmwareDownloadMessage: 'Una nueva versión {newestFirmwareVersion} está disponible..',
  customDownload: 'Descargar',
  customFieldRegistration: 'Registro de parcela.',
  customFieldCreateWithMapTitle: 'Crear una parcela en un mapa',
  customFieldCreateWithMapTitleDescription: 'Crea una nueva parcela en el mapa',
  customFieldCreateWithMapButton: 'Crear',
  customFieldCreateWithMapFieldName: 'Nombre de la parcela',
  customFieldCreateWithMapLoadingMap: 'Cargando mapa',
  customFieldCreateWithMapCreate: 'Crear',
  customFieldCreateWithMapCreateFinishedMessage: 'Parcela {fieldName} creada',
  customFieldCreateWithMapCreateErrorMessage: 'Error al crear la parcela {fieldName}',
  customFieldCreateWithMapNoFieldMessage: 'Crea una parcela en el mapa',
  customFieldCreateWithMapNoFieldNameMessage: 'Ingrese el nombre de la parcela',
  customFieldCreateWithMapTooManyFieldsMessage: 'Se puede crear una parcela.',
  customFieldUploadTitle: 'Cargar KML/Shapefile',
  customFieldUploadMessage: 'Sube tus archivos KML/KMZ o Shapefile',
  customFileUploadShapefileDescription:
    'Shapefile ZIP Archive debe contener al menos uno de cada de los siguientes tipos de archivos',
  customFieldUploadFileInput: 'Seleccione un archivo',
  customFileUploadShpDescription: '.shp (información del terreno)',
  customFileUploadShxDescription: '.shx (información del índice)',
  customFileUploadDbfDescription: '.dbf (información de atributo)',
  customFileUploadPrjDescription: '.prj (información del sistema de coordenadas geográficas)',
  customFileUploadPrjCaution: '. Se requiere prj para leer los datos de coordenadas correctamente.',
  customFileUploadTextEncodingDescription: 'Cambie este valor si el nombre del atributo está dañado',
  customFileUploadAttributeNameForFieldName: 'Nombre de atributo utilizado como nombre de parcela',
  customFileUploadFieldImportStart: 'Iniciando la importación de {count} parcelas',
  customFileUploadImportCheckTitle: 'Importación',
  customFileUploadFieldImportStartedMessage:
    'La importación de parcelas ha comenzado. Puede llevar varios minutos si hay muchas parcelas.',
  customFieldUploadErrorMessage: 'No se puede leer el archivo cargado',
  customFieldThisFieldName: 'Parcela "{fieldName}"',
  customFieldUnknownFieldName: 'Esta parcela',
  customFieldNoName: 'Sin parcela',
  customFieldDeleteAlertWithTask:
    'Hay {count} historiales de trabajo en {fieldName}. Si lo elimina, la información de la parcela en el historial de trabajo correspondiente se perderá, pero ¿está bien?',
  customFieldDeleteAlertWithoutTask: '¿Seguro que quieres eliminar {fieldName}?',
  customTextEncoding: 'Codificación',
  customFieldImportFinishedMessage: 'Se importaron correctamente las {count} parcelas.',
  customFieldImportErrorMessage: 'No se pudo importar la parcela.',
  customFieldCount: 'Número de parcelas: {count}',
  customExport: 'exportación',
  customTaskExport: 'Exportando tareas',
  customTaskWhatIsAgriBusFormat: 'El formato AgriBus es texto delimitado por TAB, por lo que es fácil de procesar.',
  customTaskNowDeveloping: 'En desarrollo',
  customTaskNowDevelopingDescription: 'En breve podrá exportar en otros formatos.',
  customTaskStartExporting: 'Comience a exportar',
  customTaskNowExporting: 'Exportando...',
  customTaskDownloadReady: 'ListaO para descargar',
  customFieldHeader: 'Parcela',
  customDarkMode: 'Modo oscuro',
  customNewRegistration: 'Nueva entrada',
  customCreateNew: 'Crear',
  customImport: 'Importar',
  customListDisplay: 'Vista de lista',
  customCardDisplay: 'Vista de tarjetas',
  customCalendarDisplay: 'Exhibición en calendario',
  customFieldsList: 'Lista de parcelas',
  customPleaseSignUpFromAndroidApplication:
    'Regístrese desde la aplicación de Android <span class="aid-logotype">AgriBus-NAVI</span>.',
  customWhatIsAgribusNAVI: 'Que es <span class="aid-logotype">AgriBus-NAVI</span>',
  customAgriBusNAVIDescription:
    '<span class="aid-logotype">AgriBus-NAVI</span> es un sistema de guía GPS para montar en maquinaria agrícola como tractores, cosechadoras y pulverizadores autopropulsados para ayudar con las tareas de línea recta en la parcela. Verificar la pantalla mientras se conduce permitirá la creación de líneas rectas y uniformemente espaciadas en parcelas grandes.',
  customProductDetails: 'Detalles de producto',
  aid: {
    calendar: {
      month: 'Mes',
      week: 'Semana',
      day: 'Día',
      fourDays: '4 dias',
    },
  },
  customTaskFilterAllSelect: 'Todo el trabajo',
  customTaskFilterGetError: 'Error al obtener información del filtro',
  customTaskFilterPostError: 'Error al registrar la información del filtro',
  customTaskFilterPutError: 'Error al actualizar la información del filtro',
  customTaskFilterDeleteError: 'Error al eliminar la información del filtro',
  customTaskFilterPostSucceed: '"{filtername}" Registrado',
  customTaskFilterPutSucceed: '"{filtername}" fue actualizado',
  customTaskFilterSetDefault: 'Ponga "{filtername}" como el filtro por defecto',
  customTaskFilterDeleteSucceed: 'La información del filtro ha sido eliminada',
  customTaskFilterSelectCheckError: 'El filtro correspondiente no existe. Por favor seleccione un filtro',
  customTaskFilterDuplicateCheckError: 'Nombre de filtro duplicado',
  customTaskFilterNotEnteredCheckError: 'No se ingresó ningún nombre de filtro',
  customTaskFilterStringNarrowing: 'Refinamiento de string',
  customTaskFilterMakeDefault: 'Utilice siempre este filtro',
  customTaskFilterName: 'Nombre del filtro',
  customTaskFilterDeleteMsg: '"{filtername}" ¿Quieres borrarlo?',
  customTaskFilterDialogTitle1: 'Filtrar historial de trabajo',
  customTaskFilterDialogTitle2: 'Aplicar configuraciones de filtro guardadas',
  customTaskFilterCreateNew: 'Crear una nueva configuración de filtro',
  customTaskFilterEdit: 'Editar un filtro',
  customTaskFilterSetting: 'Configuración del filtro',
  customTaskFilterCurrent: 'Filtro actual',
  customTaskFilterNoTasksError: 'Debido al ajuste del filtro "{filtername}", el número de elementos visualizados es 0.',
  customTaskFilterAreaZeroHidden: 'Excluyendo el trabajo con área de trabajo cero',
  customTaskFilterDistanceUnderTenHidden: 'Excluye el trabajo con menos de 10m (10.936yd) de kilometraje',
  customTaskFilterNoField: 'No hay parcelas',
  customTaskFilterNoCrop: 'No hay cosecha',
  customTaskFilterOutOfFieldHidden: 'Excluye el historial de tareas fuera de la parcela',
  customSimpleSignUpNow: 'Registrando',
  customSimpleSignUpSuccess: 'Un correo electrónico de confirmación ha sido enviado. Por favor revise su correo.',
  customEnterpriseInviteSuccess: 'Te he enviado una invitación por correo electrónico',
  customSimpleSignUpFailed: 'Registro fallido',
  customSimpleSignUpUserAlreadyExists: 'Hay un problema con su dirección de correo electrónico',
  customSimpleSignUpServerError: 'Se produjo un error durante el proceso de registro',
  customDateFilterStartDate: 'Fecha de inicio del filtro',
  customDateFilterEndDate: 'Fecha de finalización del filtro',
  customDateFilterCalendarType: 'Tipo de calendario',
  customDateFilterCalendarTypeDate: 'Día',
  customDateFilterCalendarTypeMonth: 'Mes',
  customDateFilterSetBotton: 'Set',
  customDateFilterRangeError:
    'La fecha de inicio es posterior a la fecha de finalización. Por favor seleccione una fecha nuevamente.',
  customCurrency: 'Moneda',
  customBillingCurrencyJPY: 'Yen japonés',
  customBillingCurrencyUSD: 'dólar estadounidense',
  customBillingPurchase: 'Pruebe la prueba gratuita durante 30 días.',
  customBillingPurchaseWithoutTrial: 'Actualizar',
  customBillingPlanInfo: 'Información del plan',
  customBillingNowPlan: 'Su plan',
  customBillingTrial: 'juicio',
  customBillingCancellation: 'Cancelación',
  customBillingContractPeriod: 'Periodo de contrato',
  customBillingAmount: 'Cantidad',
  customBillingAlertMustRegisterCard: 'Para comprar, debe registrar una tarjeta de crédito por adelantado.',
  customBillingMessageUnsubscribe: 'Plan de pago cancelado.',
  customBillingMessageSubscribe: 'Gracias por su compra',
  customBillingMessageUnSubscribeGoogle:
    'Actualmente estás pagando en Google Play Store. Por favor, cancele desde Google Play Store.',
  customBillingReceipt: 'Facturas / recibos',
  customBillingMessageCancelStandardPlan:
    'Si cancela su plan de pago, podrá seguir utilizando el servicio durante el periodo por el que haya pagado. Si cancelo aquí, estaré automáticamente en el plan gratuito después de {date}, ¿sigue siendo correcto?',
  customBillingMessageCancelTrial:
    'Actualmente se encuentra en el periodo de prueba, pero si lo cancela aquí, volverá inmediatamente al plan gratuito. Ten en cuenta que puedes contratar un nuevo plan de pago después de cancelar, en cuyo caso ya no se aplicará el periodo de prueba.',
  customBillingStandardDescription:
    'Un mes gratis con un plan anual de pago; aproveche todas las funciones, incluido el almacenamiento indefinido de datos y la visualización de la posición del vehículo en tiempo real de AgriBus-Web, el guiado en curva y la bandeja de información de AgriBus-NAVI.',
  customBillingMenu: 'Gestión del plan de uso.',
  customBillingMore: 'Descubre más',
  customAdRow1_1: 'Revolucione los datos del trabajo agrícola',
  customAdRow1_2: 'utilizando el Plan Estándar',
  customAdRow2_1: 'Tres beneficios',
  customAdRow2_2: 'Almacenamiento y exportación ilimitados de datos.',
  customAdRow2_3: 'Posición del vehículo en tiempo real',
  customAdRow2_4: 'Uso de AgriBus-Caster',
  customAdRow3_1: 'Tres beneficios',
  customAdRow3_2: 'Agregue diferencia de altura, velocidad de carrera, etc. a la pista de trabajo',
  customAdRow3_3: 'Guardar y recuperar la línea base de orientación',
  customAdRow3_4: 'Aplicar guía de curva',
  customOAuthMessage: 'Durante la autenticación...',
  customGoogleOAuthBtn: 'Inicia sesión con Google',
  customGoogleOAuthSignUpBtn: 'Regístrese con Google',
  customOAuthError: 'Error en el proceso de autenticación OAuth',
  customOAuthGetUserInfoError: 'Se produjo un error al obtener información de OAuth',
  customOAuthServerError: 'Se produjo un error en el proceso de registro de credenciales de OAuth',
  customOAuthFailed: 'La autenticación de OAuth falló',
  customToBillingPage: 'A la pantalla de compra del plan estándar',
  customTasksListFreePlanMsg:
    'En el Plan Gratuito, el historial de trabajo se muestra solo durante 2 días. Al suscribirse al Plan Estándar, puede tener un período de almacenamiento ilimitado.',
  customEnterprise: 'Empresa',
  customEnterpriseSetting: 'Configuración de la empresa',
  customEnterpriseManagement: 'Gestión de la empresa',
  customWhatIsEnterprise: '¿Qué es la empresa AgriBus-Web?',
  customEnterpriseRegistration: 'Inscríbase en el Plan de la Empresa',
  customPleaseContinueToRegisterForEnterprise:
    'Por favor, continúe el proceso de registro para AgriBus-Web Enterprise desde el correo electrónico que recibió.',
  customPleaseInputOrganizationName: 'Por favor, introduzca el nombre de su organización.',
  customEnterpriseName: 'Nombre de la empresa',
  customMaxOfMemberThisMonth: 'Número máximo de miembros este mes',
  customExpectedPaymentAmountForThisMonth: 'Cantidad de pago estimada para este mes',
  customDateOfPayment: 'Fecha de pago',
  customPaymentHistory: 'Historial de pagos',
  customEditEnterpriseName: 'Editar el nombre de la empresa',
  customOrganization: 'Organización',
  customOrganizationName: 'Nombre de la organización',
  customAdministrator: 'Administrador',
  customOrganizationList: 'Organigrama',
  customNewOrganization: 'Crear una nueva organización',
  customCreateOrganization: 'Crear una organización',
  customEditOrganizationName: 'Editar el nombre de la organización',
  customTeam: 'Equipo',
  customTeamList: 'Lista del equipo',
  customMyTeam: 'Mi equipo',
  customMyTeamList: 'Mi lista de equipo',
  customNewTeam: 'Creando un nuevo equipo',
  customTeamName: 'Nombre del equipo',
  customCreateTeam: 'Crear un equipo',
  customRemoveFromTeam: 'Removido del equipo',
  customEditTeam: 'Equipo de edición',
  customMember: 'Miembro',
  customMemberName: 'Nombre del miembro',
  customAddNewMember: 'Añadir un miembro',
  customNumberOfMember: 'Número de miembros',
  customInviteMembers: 'Invitar a los miembros',
  customSendInvitationEmail: 'Envía un correo electrónico de invitación',
  customPleaseEnterTheNameOfTheMember: 'Por favor, introduzca los nombres de los miembros que está invitando',
  customMemberList: 'Lista de miembros',
  customEditMember: 'Editar miembro',
  customInviting: 'Durante una invitación',
  customRestrictFollow: 'Sigue la restricción',
  customPermission: 'Derechos de acceso',
  customPermissionName: 'Nombre de la autorización de acceso',
  customRoleName: 'Nombre del papel',
  customAction: 'Acción',
  customIndividualCreation: 'Creación individual',
  customConfirmTeamDeletion: '¿Puedo quitar este equipo?',
  customConfirmMemberRemovalFromTeam: '¿Puedo quitar a este miembro del equipo?',
  customSelectTeamsForMemberToJoinDialogTitle: 'Seleccione los equipos a los que se unirá el socio',
  customSelectTeamsForMemberToJoinDialogOK: 'Añadir al equipo seleccionado',
  customSelectMembersAddToTeamDialogTitle: 'Por favor, seleccione los miembros que se unirán al equipo',
  customSelectMembersAddToTeamDialogOK: 'Añadir los miembros seleccionados',
  customFollowMembersDialogTitle: 'Seleccione un miembro para seguirlo',
  customFollowMembersDialogOK: 'Seguir al miembro seleccionado',
  customTeamFollowSelectDialogTitle: 'Seleccione un equipo para seguir',
  customTeamFollowSelectDialogOK: 'Siga a los equipos seleccionados',
  customPleaseConfirm: 'Por favor, compruébelo.',
  customEnterpriseSignUpForPleaseConfirmDescription1:
    'El usuario con la dirección de correo electrónico especificada está en el plan Estándar o Empresa.',
  customEnterpriseSignUpForPleaseConfirmDescription2:
    'Si tiene un Plan Estándar, por favor inscríbase en un plan Empresa después de haberlo cancelado.',
  customEnterpriseSignUpForFreePlanDescription:
    'Los usuarios con la dirección de correo electrónico especificada están en un Plan Gratuito. ¿Puedo cambiar al plan Enterprise?',
  customEnterpriseSignUpForStandardPlanDescription:
    'El usuario con la dirección de correo electrónico especificada ha cancelado su plan Estándar, pero aún está activo. ¿Desea cambiar al plan Enterprise? (Tenga en cuenta que si el usuario aún debe el plan estándar, se le cobrará tanto el plan estándar como el plan de empresa.)',
  customAddFollowMembers: 'Añadir un miembro de seguimiento',
  customAddFollowTeams: 'Añade un equipo de seguimiento',
  customBillingMaxMember: 'Número máximo de miembros',
  customCreditCardRegistration: 'Registro de la tarjeta de crédito',
  customNext: 'Siguiente',
  customGoBackOneStep: 'Volver a la anterior',
  customRestriction: 'Restricción',
  customMemberSuspension: '¿Estás seguro de que quieres dejar de usar este miembro?',
  customResumeMemberUsage: '¿Estás seguro de que quieres seguir usando este miembro?',
  customRestart: 'Reinicie',
  customSuspended: 'Suspendido',
  customAddToExistingTeam: 'Añade al equipo',
  customFollowFunction: 'Función de seguimiento',
  customAllowToAddAndRemoveFollow: 'Permitir que se añada y se elimine lo siguiente',
  customAllowToAddAndRemoveFollowDescription:
    'A este miembro no se le permite añadir o quitar seguidores por sí mismo.',
  customNotAllowToAddAndRemoveFollow: 'No permitir que se añada y se elimine el seguimiento',
  customNotAllowToAddAndRemoveFollowDescription: 'Este miembro es libre de añadir y quitar seguidores.',
  customEnterprisePlanDisplayName: 'Plan de empresa',
  customPricePerMember: 'Precio por miembro.',
  customPerMember: 'Por cada miembro',
  customNotesOnPlanSelection:
    'La cantidad facturada es el número máximo de miembros en el mes de facturación x el precio unitario.',
  customDueDateForFirstRepayment: 'Fecha de vencimiento para el primer reembolso',
  customEnterprisePlanStart: 'Comienza',
  customUnsubscribeFromEnterprise: 'Cancelar la suscripción del Plan de la Empresa',
  customReturnAgriBusWeb: 'Volver a la Web de Agri-Bus',
  customAboutCreditCardPayment: 'Sobre el pago con tarjeta de crédito',
  customClickHereUnsubscripbeFromEnterprise: 'Haga clic aquí para darse de baja del plan de la empresa.',
  customEnterpriseWithdrawText1:
    'Debido al retiro de la membresía, la factura de este mes será la última de este mes y no se harán más pagos.',
  customEnterpriseWithdrawText2:
    'Continuaremos desarrollando cada producto de la serie AgriBus en el futuro, así que si tiene la oportunidad, por favor, eche un vistazo de nuevo.',
  customEnterpriseWithdrawText3:
    'Nos gustaría agradecerles por usar cada uno de los productos de la serie AgriBus, aunque sólo sea por un momento. Gracias por su interés en nuestros productos.',
  customErrorEnterpriseWithdraw: 'No canceló su plan para el Enterprise. Por favor, inténtelo de nuevo.',
  customGuidanceInterval: 'intervalo de orientación',
  customWorkingWidth: 'ancho de trabajo',
  customRefLineLength: 'longitud de la línea de guiado',
  customRefLine: 'línea de referencia',
  customExportRefLine: 'Exportar una línea de base',
  customDirecton: 'dirección',
  customShowTaskDetailError:
    'No hay historial de trabajo; puede haber estado fuera de sincronía con AgriBus-NAVI o haber sido borrado.',
  customFileUploadAttributeNameForRefLineName: 'Nombre del atributo que se utilizará como línea de base',
  customFileUploadRefLineImportStart: 'Comienza a capturar {count} líneas de referencia.',
  customFileUploadShapefileDescriptionForRefLines:
    'El Shapefile requiere un archivo zip (comprimido) para los siguientes archivos solamente',
  customFileUploadShpDescriptionForRefLines: 'Swaths.shp (Información topográfica)',
  customFileUploadShxDescriptionForRefLines: 'Swaths.shx (información sobre el índice)',
  customFileUploadDbfDescriptionForRefLines: 'Swaths.dbf (información de atributos)',
  customRefLineImportFinishedMessage: 'Hemos logrado capturar {count} líneas de referencia.',
  customRefLineImportErrorMessage: 'No logré capturar una línea de base.',
  customRefLineAddTitle: 'Nuevo registro de la línea de referencia',
  customRefLineImportTitle: 'Cargando Shapefile',
  customRefLineImportText: 'Sube tu Shapefile',
  customRefLineImportText2: 'Sólo se pueden importar las líneas de referencia que salen del Trimble CFX-750.',
  customRefLineCreateTitle: 'Crear una línea de base en un mapa',
  customRefLineCreateText: 'Crear una línea de base en el mapa',
  customRefLineUploadTitle: 'Subir una línea de base',
  customRefLineNameHint: 'nombre de la línea de referencia',
  customRefLineDeleteAlert: '¿Estás seguro de que quieres borrar {refLineName}?',
  customRefLineDeleteUnknownName: 'Esta línea de referencia',
  customRefLineDeleteKnownName: 'Línea de referencia "{refLineName}".',
  customRefLineDeleteError: 'No se borró la línea de referencia.',
  customThunderstormWithLightRain: 'Tormenta eléctrica con lluvia ligera',
  customThunderstormWithRain: 'Tormenta eléctrica con lluvia',
  customThunderstormWithHeavyRain: 'Tormenta eléctrica con fuertes lluvias',
  customThunderstormWithLightDrizzle: 'Tormenta eléctrica con llovizna ligera',
  customThunderstormWithDrizzle: 'Tormenta eléctrica con llovizna',
  customThunderstormWithHeavyDrizzle: 'Tormenta eléctrica con una fuerte llovizna',
  customThunderstormWithHail: 'Tormenta eléctrica con granizo',
  customLightDrizzle: 'Llovizna ligera',
  customDrizzle: 'Llovizna',
  customHeavyDrizzle: 'Llovizna fuerte',
  customLightRain: 'Lluvia ligera',
  customModerateRain: 'Lluvia moderada',
  customHeavyRain: 'Lluvia fuerte',
  customFreezingRain: 'Lluvia helada',
  customLightShowerRain: 'Lluvia ligera de lluvia',
  customShowerRain: 'Lluvia de lluvia',
  customHeavyShowerRain: 'Lluvia fuerte de lluvia',
  customLightSnow: 'Nieve ligera',
  customSnow: 'Nieve',
  customHeavySnow: 'Nieve pesada',
  customMixSnowRain: 'Mezclar nieve/lluvia',
  customSleet: 'Sleet',
  customHeavySleet: 'Aguanieve pesado',
  customSnowShower: 'Ducha de nieve',
  customHeavySnowShower: 'Una fuerte lluvia de nieve',
  customFlurries: 'Ráfagas',
  customMist: 'Niebla',
  customSmoke: 'Humo',
  customHaze: 'Haze',
  customSandDust: 'Arena/polvo',
  customFog: 'Niebla',
  customFreezingFog: 'Niebla helada',
  customClearSky: 'Cielo despejado',
  customFewClouds: 'Pocas nubes',
  customScatteredClouds: 'Nubes dispersas',
  customBrokenClouds: 'Nubes rotas',
  customOvercastClouds: 'Nubes nubladas',
  customUnknownPrecipitation: 'Precipitación desconocida',
  customWeatherInfoTitle: 'Información meteorológica',
  customWeatherDescriptionTitle: 'el tiempo',
  customWindSpeedTitle: 'la velocidad del viento',
  customTemperatureTitle: 'temperatura',
  customRelativeHumidityTitle: 'nivel de humedad',
  customNumOfSatellites: 'número de satélites',
  customGnssStatus: 'Estado del GNSS',
  customLeftRightMisalignment: 'desalineación',
  customAzimuthShift: 'desplazamiento acimutal',
  customGradient: 'gradiente',
  customTimeOfAcquisition: 'tiempo de adquisición',
  customWorkOverview: 'resumen del trabajo',
  customImageStorage: 'almacenamiento de imágenes',
  customMapGaugeDescriptionNone: 'Se muestra el relleno de la obra sin código de colores',
  customMapGaugeDescriptionHeight: 'La diferencia de altura de la obra se muestra por colores',
  customMapGaugeDescriptionSpeed: 'La velocidad del trabajo se muestra por colores',
  customMapGaugeDescriptionNumOfSatellites:
    'El número de satélites de posicionamiento en el momento de la operación se muestra en diferentes colores',
  customMapGaugeDescriptionGnssStatus: 'El estado del GNSS en el momento del trabajo se muestra por colores.',
  customMapGaugeDescriptionLeftRightMisalignment:
    'La desviación izquierda-derecha de la guía durante el funcionamiento se muestra por colores.',
  customMapGaugeDescriptionAzimuthShift:
    'Indicación por colores de la desalineación con orientación durante el funcionamiento',
  customMapGaugeDescriptionGradient:
    'La inclinación en el trabajo se muestra en diferentes colores (G2, GMiniR, sólo Gmini).',
  customPrecipitationTitle: 'Precipitación',
  customWeathercomTornado: 'Tornado',
  customWeathercomTropicalStorm: 'Tormenta tropical',
  customWeathercomHurricane: 'Huracán',
  customWeathercomStrongStorms: 'Tormentas fuertes',
  customWeathercomThunderstorms: 'Tormentas eléctricas',
  customWeathercomRainSnow: 'Lluvia Nieve',
  customWeathercomRainSleet: 'Aguanieve',
  customWeathercomWintryMix: 'Mezcla invernal',
  customWeathercomFreezingDrizzle: 'Llovizna congelada',
  customWeathercomDrizzle: 'Llovizna',
  customWeathercomFreezingRain: 'Lluvia helada',
  customWeathercomShowers: 'Duchas',
  customWeathercomRain: 'Lluvia',
  customWeathercomFlurries: 'Ráfagas',
  customWeathercomSnowShowers: 'Duchas de nieve',
  customWeathercomBlowingDriftingSnow: 'Soplando nieve a la deriva',
  customWeathercomSnow: 'Nieve',
  customWeathercomHail: 'Salve',
  customWeathercomSleet: 'Sleet',
  customWeathercomBlowingDustSandstorm: 'Tormenta de arena de polvo soplado',
  customWeathercomFoggy: 'Foggy',
  customWeathercomHaze: 'Haze',
  customWeathercomSmoke: 'Humo',
  customWeathercomBreezy: 'Breezy',
  customWeathercomWindy: 'Viento',
  customWeathercomFrigidIceCrystals: 'Cristales de hielo fríos',
  customWeathercomCloudy: 'Nublado',
  customWeathercomMostlyCloudy: 'Mayormente nublado',
  customWeathercomPartlyCloudy: 'Parcialmente nublado',
  customWeathercomClear: 'Despejado',
  customWeathercomSunny: 'Sunny',
  customWeathercomFairMostlyClear: 'Bastante claro',
  customWeathercomFairMostlySunny: 'Bastante soleado',
  customWeathercomMixedRainandHail: 'Lluvia y granizo mezclados',
  customWeathercomHot: 'Caliente',
  customWeathercomIsolatedThunderstorms: 'Tormentas aisladas',
  customWeathercomScatteredThunderstorms: 'Tormentas eléctricas dispersas',
  customWeathercomScatteredShowers: 'Duchas dispersas',
  customWeathercomHeavyRain: 'Lluvia fuerte',
  customWeathercomScatteredSnowShowers: 'Lluvias de nieve dispersas',
  customWeathercomHeavySnow: 'Nieve pesada',
  customWeathercomBlizzard: 'Ventisca',
  customWeathercomNotAvailable: 'No está disponible',

  customSharedMountPointSetting: 'Ajuste del punto de montaje',
  customSharedMountPointSettingTitle:
    'Establezca el punto de montaje de la estación de referencia RTK que se compartirá dentro de la organización.',
  customSharedMountPoint: 'punto de montaje compartido',
  customMountPoint: 'punto de montaje',
  customStatus: 'estado',
  customNotSet: 'No se ha fijado.',
  customSelectMountPoint: 'Seleccione el punto de montaje',
  customUnsharedMountPoint: 'No compartido',
  customSelectMountPointTitle: 'Seleccione el punto de montaje para compartir',
  customSharedMountPointRemarks1:
    'Los puntos de montaje se emiten cuando el AgriBus-GMiniR se establece como estación de referencia utilizando la aplicación AgriBus-GTools. Si utiliza una estación de referencia de otro fabricante, solicítela desde el siguiente enlace.',
  customSharedMountPointRemarks2: 'Haga clic aquí para solicitarlo.',
  customOnline: 'en línea',
  customOffline: 'fuera de línea',
  customNotIssued: 'no emitido',
  customSetItUp: 'Estamos listos.',
  customDeActivated: 'Desactivado.',
  customType: 'clasificación',
  customCropIsNotRegistered: 'El cultivo no está registrado.',
  customNameNotRegistered: 'Nombre no registrado',

  customGoToPayerManager: 'Abrir la página de administración',
  customPaymentInfo: 'Información de pago',
  customProjectInfo: 'Información sobre el proyecto',
  customAddProject: 'Añadir proyecto',
  customAddProjectRemarks: 'Especifique el nombre del proyecto y la dirección de correo electrónico del administrador',
  customProjectName: 'Nombre del proyecto',
  customProjectAdminMailAddress: 'Correo electrónico del administrador',
  customStop: 'suspensión',
  customStopDialogText: '¿Desea eliminar el proyecto seleccionado?',
  customDone: 'Ya está hecho.',
  customUpdateDay: 'fecha de actualización',
  customAdminName: 'Nombre del gerente',
  customMaxQuantity: 'número máximo de personas',
  customaddProjectSuccess: 'Su proyecto ha sido añadido.',
  customPlantingShowPast: 'Mostrar plantaciones anteriores',
  customPlantingHidePast: 'Ocultar plantaciones anteriores',
  customPlantingCropDisplayName: 'nombre de visualización del cultivo',
  customPlantingCropVarietyName: 'Nombre de la variedad',
  customPlantingSeason: 'Temporada de cultivo',
  customPlantingSeasonStartDate: 'Fecha de inicio (obligatoria)',
  customPlantingSeasonEndDate: 'Fecha de finalización',
  customPlantingAddCropOption: 'Añadir opción de cultivo',
  customPlantingRemoveCropOption: 'Eliminar la opción de cultivo',
  customPlantingCropSelectionRequiredError:
    'Debe seleccionar esta opción. Si no se aplica ninguno, seleccione "Otros".',
  customPlantingOtherCropSelectionRequiredError: 'Debe introducirse si se ha seleccionado "Other"',
  customPlantingDeleteConfirmationMessage:
    '¿Quieres eliminar {plantingName}? (Los datos asociados también se eliminarán).',
  customPlantingFieldSelectionHint: 'Si el nombre de la parcela no está configurado, no aparecerá en la lista',

  customTaskDeleteMessage: '¿Está seguro de que quiere eliminar la obra seleccionada?',
  customTaskDeleteFailure: 'No se ha podido eliminar la obra seleccionada',
  customTaskDeleteSucceed: 'Ha eliminado con éxito la obra seleccionada',

  customErrorStartDateRequired: 'La fecha de inicio es obligatoria',
  customErrorFieldRequired: 'Las parcelas son esenciales',

  customAlreadyExistingUser:
    'Ya has registrado tu dirección de correo electrónico. Utilice una dirección de correo electrónico no registrada.',

  customNowProgressRateTitle: 'Progreso del trabajo',
  customNowProgressRateNotField: 'No hay parcelas relevantes',

  customStandardSubscribeErrorMessage:
    'Su compra de suscripción ha fallado. Por favor, compruebe de nuevo la información que ha introducido.',
  customStripeCouponText1: 'Haga clic aquí para canjear su vale',
  customStripeCouponText2: 'Haga clic aquí para ver el código del cupón',

  customUpdatePolygonFailure: 'No he actualizado mis parcelas.',

  customMultiPolygonImportError:
    'Datos que contienen MultiPolígonos, que deben ser convertidos a Polígonos ya que los MultiPolígonos no son soportados.',

  customSimpleSignUpAndSignInError:
    'Hay un problema con su dirección de correo electrónico o contraseña. Por favor, compruébalo.',
  customNewPasswordValidationError: 'Se requiere al menos una letra minúscula y un número.',

  // 2022.12.08
  customSelectPlanSelectPaymentMethodText: 'Seleccione un método de pago',
  customCardInfoHasNotBeenEnteredError: 'Introduzca los datos de su tarjeta',
  customNoPaymentMethodSeletedError: 'No se ha seleccionado ningún método de pago.',
  customFreeDashBoardText1:
    'Se requiere una suscripción al plan de pago (AgriBus Professional) para iniciar sesión en AgriBus-Web.',
  customFreeDashBoardText2: 'Más información.',
  customFreeDashBoardText3: 'Aviso.',
  customFreeDashBoardText4: '',
  customContractPlanTitle: 'Plan contractual',
  customComparePlansText: 'Comparar planes',
  customUpgradeToPlusText: 'Cambiar a Plus',
  customDowngradeToPlusText: 'Baja a Plus.',
  customUpgradeToProfessionalText: 'Actualizar a AgriBus Professional',
  customBillingBillingText1: 'Cancelado: se convierte automáticamente en un plan gratuito cuando caduca.',
  customUpgradeConfirematoinText: 'Actualizaré a AgriBus Professional. ¿Te parece bien?',
  customDowngradeConfiremationText: 'Bajaremos a Plus. ¿Puedo?',
  customBankTransfer: 'transferencia bancaria',
  customHome: 'Inicio',
  customBillingMessageSubscribeGoogle:
    'Actualmente estás suscrito a Google Play Store; actualiza/desactualiza tu suscripción en Google Play Store.',
  customInvoiceReceiptAddresseeTitle: 'Dirección de facturación/recibo',
  customChangeAddresseeBtnText: 'Cambia la dirección.',
  customBillingEmailAddressTitle: 'Dirección de correo electrónico de facturación',
  customChangeBillingEmailAddressText: 'Cambiar la dirección de correo electrónico de facturación',
  customCannotDowngradeText: 'Las transferencias bancarias no pueden pasar a Plus.',
  customChangePaymentMethodsToCard: 'Cambio al pago con tarjeta',
  customChangePaymentMethodsToCustomerBalance: 'Cambio a transferencia bancaria',
  customChangePaymentMethodToSendInvoiceText: '¿Puedo cambiar mi forma de pago a transferencia bancaria?',
  customMapGaugeDescriptionColorCodedFill:
    'Si la aplicación se ha pintado por colores, se muestra un historial de trabajo codificado por colores.',
  customColorCodeFill: 'Rellenar por color',
  customSelectDefaultIconTitle: 'Seleccione un icono',
  customImportLimitMessage: 'El número máximo de importaciones es {limit}.',
  customPresetIcon: {
    title: 'Preestablecido',
    description: 'Elige entre seis preajustes diferentes.',
    btnText: 'Seleccionar entre preselecciones',
  },
  customBulkDeleteCheckboxText: 'borrado masivo',
  customBulkDeleteDialogText: '¿Puedo realizar un borrado masivo?',
  customPerimeter: 'Perímetro',
  feed: {
    menu: 'Feed',
    title: 'Noticias',
    description:
      'Estadísticas diarias (anónimas) de la actividad agrícola regional y novedades de las zonas productoras.',
    yourArea: 'Actividad en tu zona (~33 km)',
    areaFromFields: 'Detectado desde tus parcelas',
    widerArea: 'Zona ampliada (~55 km)',
    national: 'Actividad nacional',
    daily: 'Ayer',
    weekly: 'Últimos 7 días',
    monthly: 'Últimos 28 días',
    vsNormal: 'vs normal',
    vsLastYear: 'vs año anterior',
    noData: 'Datos insuficientes en esta zona (pocas operaciones cercanas).',
    noAreaHint: 'Registra tus parcelas para ver las estadísticas de tu zona.',
    nationalFallback: 'Abajo se muestran las estadísticas nacionales.',
    upsell: 'Los planes de pago añaden las ventanas diaria y de 28 días, y la vista ampliada de ~55 km.',
    monitorTitle: 'Informe semanal del monitor',
    monitorActive: 'Patrón de observación activo',
    monitorNone: 'Sin patrón de observación',
    toMarketInsights: 'Abrir Market Insights',
    loadError: 'No se pudo cargar el feed. Inténtalo de nuevo más tarde.',
    disclaimer: 'La actividad regional es una estadística anónima, no una evaluación de fincas individuales.',
    kindNews: 'Noticias',
    kindPr: 'PR',
    readMore: 'Más información',
    entryDaily: 'Actividad de trabajo del {date}',
    entryWeekly: 'Resumen semanal (hasta {date})',
    areaC3: 'Tu zona',
    areaC5: 'Zona amplia',
    areaJp: 'Todo el país',
    historyTitle: 'Tendencia pasada',
    kindSignal: 'Señal',
    shareTitle: 'Compartir en el feed',
    share: 'Compartir',
    shareVisibility: 'Visibilidad',
    visFollowers: 'Solo seguidores',
    visNeighborhood: 'Vecindario',
    visPublic: 'Público',
    shareRoute: 'Mostrar recorrido de trabajo',
    shareExact: 'Compartir ubicación exacta (fondo de mapa)',
    statTime: 'Tiempo',
    statDistance: 'Distancia',
    statArea: 'Área',
    statWidth: 'Ancho',
    statSpeed: 'Velocidad',
    statGnss: 'GNSS',
    shareComment: 'Comentario',
    shareSubmit: 'Compartir',
    sharePosted: 'Compartido',
    shareFailed: 'No se pudo completar. Inténtalo más tarde.',
    consentNote:
      'Tu publicación se muestra a los usuarios del alcance seleccionado. La ubicación se muestra solo como zona aproximada (unos 11 km).',
    consentLabel: 'Acepto los términos de compartir (art. 15-2)',
    postDelete: 'Eliminar',
    postDeleted: 'Publicación eliminada',
    postDeleteConfirm: '¿Eliminar esta publicación?',
    report: 'Denunciar',
    reportTitle: 'Denunciar publicación',
    reportConfirm: '¿Denunciar esta publicación al operador?',
    reportReason: 'Motivo (opcional)',
    reportDone: 'Denuncia enviada. Gracias',
    visPrivate: 'Solo yo',
    followRequested: 'Solicitado',
    followAccept: 'Aceptar',
    followDecline: 'Rechazar',
    followAccepted: 'Solicitud de seguimiento aceptada',
    unfollow: 'Dejar de seguir',
    unfollowConfirm: '¿Dejar de seguir a este usuario?',
    connectionsHint:
      'Envía solicitudes de seguimiento desde las publicaciones del feed. Una vez aceptadas, verás las publicaciones solo para seguidores',
    sharePhotos: 'Agregar fotos (hasta 4)',
    sharePhotosHint: 'Los metadatos de ubicación (EXIF) se eliminan automáticamente',
    snsShare: 'Compartir',
    copyLink: 'Copiar enlace',
    linkCopied: 'Enlace copiado',
    shareOther: 'Otras aplicaciones',
    instagramSaved: 'Imagen guardada. Publícala desde la aplicación de Instagram',
    manualRecords: 'Registros manuales',
    addManualRecord: 'Agregar registro manual',
    manualChip: 'Manual',
    recordStart: 'Inicio',
    recordEnd: 'Fin',
    recordMemo: 'Nota',
    recordDuration: 'Duración (min)',
    recordCreated: 'Registro agregado',
    recordDeleteConfirm: '¿Eliminar este registro?',
    noManualRecords: 'Aún no hay registros manuales',
    poiRecords: 'Puntos de interés',
    addPoi: 'Agregar punto de interés',
    poiTitle: 'Titulo',
    poiMapHint: 'Haga clic en el mapa para fijar el punto. Si no, se usa la ubicación de la foto',
    noPoiRecords: 'Aún no hay puntos de interés',
    map: 'Mapa',
    mapLayers: 'Capas',
    editMode: 'Modo edición',
    selected: 'Seleccionadas',
    mergeSave: 'Guardar combinado',
    clipDraw: 'Dibujar área de recorte',
    saveAsField: 'Guardar área sembrada como parcela',
    workWidthM: 'Ancho de trabajo (m)',
    workName: 'Nombre',
    workSaved: 'Registro derivado guardado',
    derivedRecords: 'Registros derivados',
    derivedChip: 'Derivado',
    derivedDeleteConfirm: '¿Eliminar este registro derivado?',
    saveRangeAsWork: 'Guardar rango seleccionado como registro derivado',
    clipByField: 'Recortar por parcela',
    showOnMap: 'Mostrar en el mapa',
    editRange: 'Editar rango',
    trajectoryChip: 'GPS',
    derivedRecordsDescription:
      'Registros de trabajo emparejados 1:1 con cada trayectoria. Los registros editados y manuales también aparecen aquí',
    spatialEdit: 'Recortar / Guardar parcela',
    vraTitle: 'Mapa VRA',
    vraDescription: 'Genere mapas de zonas para aplicación variable a partir de índices de vegetación satelitales',
    vraGenerate: 'Generar nuevo mapa',
    vraIndex: 'Índice de vegetación',
    vraGridSize: 'Cuadrícula (m)',
    vraDirection: 'Dirección (grados)',
    vraCloudPct: 'Nubes máx. (%)',
    vraImages: 'Imágenes usadas',
    vraFailed: 'Falló la generación. Puede que no haya imágenes sin nubes en el período',
    saveFailed: 'Error al guardar',
    mapSetGenerated: 'Generación completada',
    fieldValidFromDate: 'Válido desde: {date}',
    fieldDeleteLinked: '{fieldName} no se puede eliminar porque está vinculado a los siguientes datos.',
    fieldDeleteLinkedTasks: 'Registros de trabajo: {count}',
    fieldDeleteLinkedSets: 'Conjuntos de campos: {names}',
    fieldDeleteLinkedHint: 'Para eliminarlo, primero quite los registros de trabajo y conjuntos vinculados.',
    elevSource: 'Fuente',
    elevSourceDem: 'Satélite (DEM)',
    elevSourceGnss: 'Historial de trabajo (GNSS)',
    elevCenter: 'Centro de color',
    elevCenterMean: 'Media',
    elevCenterMedian: 'Mediana',
    elevCenterValue: 'Elevación central',
    elevCustom: 'Personalizado',
    elevRange: 'Rango de color',
    elevRangeWidth: 'Ancho del rango',
    elevContour: 'Curvas de nivel',
    zoneBands: 'Zonas',
    zonePalette: 'Color scheme',
    paletteHue: 'HSI (green→yellow→red)',
    paletteYlgn: 'Yellow→Green',
    paletteGnrd: 'Green→Red',
    reclassifyTitle: 'Cambiar zonas/colores (sin regenerar)',
    reclassifyApply: 'Aplicar reclasificación',
    followByEmail: 'Solicitud de seguimiento por correo',
    emailUserNotFound: 'No se encontró ningún usuario con este correo',
    followRequestSent: 'Solicitud de seguimiento enviada',
    eventSettingsTitle: 'Feed settings (auto events)',
    eventSettingsVisibility: 'Event visibility',
    eventSettingsLocation: 'Location visibility',
    eventSettingsSnsStrip: 'Strip exact location when sharing to SNS (default)',
    eventSettingsPrefs: 'Events posted to your feed',
    locHidden: 'Hidden',
    locApprox: 'Approximate (~10 km grid)',
    locExact: 'Include exact location',
    event_work_start: 'Work started',
    event_work_end: 'Work finished',
    event_field_enter: 'Entered field',
    event_field_exit: 'Left field',
    event_poi_added: 'POI added',
    event_vra_map_added: 'VRA map added',
    event_elevation_map_added: 'Height map added',
    event_refline_added: 'Guidance line added',
    event_field_added: 'Field added',
    event_field_set_added: 'Field set added',
    event_work_start_text: 'started working ({name})',
    event_work_end_text: 'finished working ({name})',
    event_field_enter_text: 'entered field \u201c{name}\u201d',
    event_field_exit_text: 'left field \u201c{name}\u201d',
    event_poi_added_text: 'added POI \u201c{name}\u201d',
    event_vra_map_added_text: 'created VRA map \u201c{name}\u201d',
    event_elevation_map_added_text: 'created height map \u201c{name}\u201d',
    event_refline_added_text: 'added guidance lines ({name})',
    event_field_added_text: 'added field \u201c{name}\u201d',
    event_field_set_added_text: 'created field set \u201c{name}\u201d',
    vraNameAuto: 'Nombre (vacío = automático)',
    eventPrefOff: 'Do not post',
    visEditTitle: 'Change visibility',
    visEditLocationExact: 'Show exact location (map background)',
    visEditRemoveLocation: 'Remove exact location',
    visEditPublicNote: 'Exact location is automatically excluded for public posts',
    consentRequiredToShare: 'Sharing requires consent to the sharing terms. Enable sharing from a regular post first',
    elevGnssFailed:
      'Falló el cálculo de desnivel. No hay historial de trabajo (elevaciones GNSS) que coincida con los filtros, o aún se está procesando. Pruebe a relajar el filtro GNSS o el rango de fechas',
    elevDescription:
      'Genere mapas de desnivel a partir de elevaciones GNSS del historial de trabajo (se recomienda RTK). Sin historial, también se pueden usar datos satelitales (DEM). Se sincroniza con NAVI como los mapas VRA',
    fieldValidUntil: 'Válido hasta: {date}',
    mapSetGeneratedWithCount:
      'Generados {created} / fallidos {failed} (los mapas existentes de los mismos campos se reemplazan)',
    vraGenerating: 'Analizando imágenes satelitales...',
    vraObsDate: 'Fecha de observación',
    vraPeriodMean: 'Promedio del período',
    vraLimitReached: 'Límite de generación alcanzado (Free: 3 en total, planes de pago: 10 por día)',
    vraExport: 'Exportar ISOXML',
    vraModeGrid: 'Malla (cuadrícula)',
    vraModePolygon: 'Polígono',
    vraRate: 'Dosis (kg/ha)',
    vraCellSize: 'Tamaño de celda (m)',
    vraEditMap: 'Editar',
    mapSets: 'Conjuntos de parcelas',
    mapSetDescription:
      'Agrupe parcelas con un filtro (período de validez, cultivo, nombre). Se usa para generar mapas VRA en lote',
    mapSetCreate: 'Crear conjunto de parcelas',
    fieldSetEmpty: 'Aún no hay conjuntos de parcelas',
    mapSetTargetDate: 'Fecha objetivo',
    mapSetCrop: 'Cultivo',
    mapSetNameContains: 'Nombre (contiene)',
    mapSetMemoContains: 'Memo (contiene)',
    mapSetPreviewCount: 'Parcelas coincidentes',
    mapSetGenerate: 'Generar/Actualizar',
    mapSetFields: 'Parcelas',
    mapSetLastGenerated: 'Última generación',
    fieldAttrsTitle: 'Atributos de parcela (vigencia y cultivo)',
    fieldValidFrom: 'Válido desde (vacío = ilimitado)',
    fieldValidTo: 'Válido hasta (vacío = ilimitado)',
    mapSetNoMatch: 'Ninguna parcela coincide',
    mapSetDeleteConfirm: '¿Eliminar este conjunto de parcelas y los mapas VRA generados a partir de él?',
    trajectories: 'Trayectorias',
  },
  marketInsights: {
    menu: 'Información de mercado',
    title: 'Información de mercado (AgriBus-DWH)',
    description:
      'Consulte a diario el avance de los trabajos y las observaciones de mercado de las principales zonas productoras de soja y trigo del mundo. Es un beneficio para miembros: sus datos de trabajo (estadísticas anónimas) vuelven a usted como información útil, por ejemplo, para decidir cuándo vender.',
    soybeanDescription: 'Situación de los cultivos y señales de mercado de las zonas sojeras de Brasil y EE. UU.',
    wheatDescription: 'Situación de los cultivos y señales de mercado de las zonas trigueras',
    open: 'Abrir',
    upsell:
      'La información de mercado es un beneficio para miembros con plan de pago. Con un plan de pago puede verla sin costo adicional.',
    memberNote:
      'Al verla como miembro se muestra una insignia arriba a la izquierda del monitor. Esta información no es una recomendación de inversión.',
  },
}
